import { useNavigate, Link } from "react-router-dom";
import ItemsTab from "../../../components/itemstab";
import React from "react";
import {
  MdOutlineAccountBalance,
  MdOutlineBrightness4,
  MdOutlineErrorOutline,
  MdOutlineLogout,
  MdOutlinePerson,
  MdOutlineSettings,
  MdOutlineToggleOff,
  MdOutlineToggleOn,
  MdCached,
} from "react-icons/md";
// @ts-ignore
import bback from "assets/images/bback.png";
import NotificationIcon from "../../../components/NotificationIcon";

import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../../../features/loggedInUser.features";
import { logoutGuardianUser } from "../../../features/guardianUser.features";
import { setTheme } from "../../../features/theme.features";
import { persistor, RootState } from "../../../store";
import { Role } from "../../../generated/graphql";

export default function MyAccount() {
  // @ts-ignore
  const theme = useSelector((state: RootState) => state.theme.data);
  const user = useSelector((state: RootState) => state.loggedInUser.data);
  const loggedInRole = useSelector(
    (state: RootState) => state.loggedInUser.role
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function handleAccountSwitch() {
    navigate("/app/account/choose/role", {
      state: { user: user },
    });
  }

  function handleLogout() {
    persistor.purge();
    dispatch(logoutGuardianUser());
    dispatch(logoutUser());
    navigate("/");
  }


  return (
    <div className="relative pb-6">
      <div className="sticky top-0 px-4 pt-4 pb-2 bg-white dark:bg-[#010A18]">
        <div className="flex items-center">
          <h1>My Account</h1>
          <button className="ml-auto">
            <NotificationIcon />
          </button>
        </div>
        <p className="text-sm text-gray-300">{`${user?.profile?.firstName} ${user?.profile?.lastName}`}</p>
      </div>

      <div className="my-6 px-4 grid gap-2">
        <ItemsTab
          onClick={() =>
            dispatch(setTheme(theme === "light" ? "dark" : "light"))
          }
          className="ring-1 ring-gray-300 !py-4"
          leading={<MdOutlineBrightness4 className="text-2xl" />}
          trailing={
            <>
              <MdOutlineToggleOff
                className="text-2xl dark:hidden"
                aria-hidden
              />
              <MdOutlineToggleOn
                className="text-2xl hidden dark:block"
                aria-hidden
              />
            </>
          }
        >
          <p className="text-left">Enable Dark Mode</p>
        </ItemsTab>

        {(user.role === Role.Chw ||
          user.role === Role.Practitioner ||
          user.linkedMinorAccount) && (
            <ItemsTab
              className="ring-1 ring-gray-300 !py-4"
              leading={<MdCached aria-hidden className="text-2xl" />}
              onClick={handleAccountSwitch}
              trailing={undefined}
            >
              <p className="text-left">Switch Profile</p>
            </ItemsTab>
          )}

        <Link to="/app/account/profile">
          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={<MdOutlinePerson aria-hidden className="text-2xl" />}
            trailing={undefined}
          >
            <p className="text-left">My Profile</p>
          </ItemsTab>
        </Link>

        {(loggedInRole === Role.Patient ||
          loggedInRole === Role.Minor) && (
            <Link to="/app/account/prescriptions">
              <ItemsTab
                className="ring-1 ring-gray-300 !py-4"
                leading={<MdOutlinePerson aria-hidden className="text-2xl" />}
                trailing={undefined}
              >
                <p className="text-left">My Prescriptions</p>
              </ItemsTab>
            </Link>
          )}

        <Link to="/app/account/calender">
          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={<MdOutlinePerson aria-hidden className="text-2xl" />}
            trailing={undefined}
          >
            <p className="text-left">My Calender</p>
          </ItemsTab>
        </Link>

        <Link to="/app/account/balance">
          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={<MdOutlinePerson aria-hidden className="text-2xl" />}
            trailing={undefined}
          >
            <p className="text-left">My Balance</p>
          </ItemsTab>
        </Link>

        <Link to="/app/account/settings">
          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={<MdOutlineSettings aria-hidden className="text-2xl" />}
            trailing={undefined}
          >
            <p className="text-left">My Settings</p>
          </ItemsTab>
        </Link>

        {/* <ItemsTab
          className="ring-1 ring-gray-300 !py-4"
          leading={<MdOutlineAccountBalance aria-hidden className="text-2xl" />}
          trailing={undefined}
        >
          <p className="text-left">Access Loans</p>
        </ItemsTab> */}

        <Link to="/app/account/help">
          <ItemsTab
            className="ring-1 ring-gray-300 !py-4"
            leading={<MdOutlineErrorOutline aria-hidden className="text-2xl" />}
            trailing={undefined}
          >
            <p className="text-left">Help</p>
          </ItemsTab>
        </Link>

        <ItemsTab
          onClick={handleLogout}
          className="ring-1 ring-gray-300 !py-4"
          leading={<MdOutlineLogout className="text-2xl text-pink" />}
          trailing={undefined}
        >
          <p className="text-left text-pink">Log Out</p>
        </ItemsTab>
      </div>

      <div className="relative" style={{ zIndex: "-10" }}>
        <img
          src={bback}
          alt="bback"
          className="fixed -bottom-10 w-[480px] px-0"
        />
      </div>
    </div>
  );
}
